<template>
  <div class="card card-custom gutter-b" v-loading="loading">
    <div class="card-header d-flex justify-content-between">
      <div class="card-title">
        <h3 class="card-label">Bài thi học viên ca thi {{ examName }}</h3>
      </div>
    </div>
    <div class="card-body display-grid">
      <div style="background: #ebf4fd; padding: 8px; border-radius: 8px; border: 1px solid gray; width: 100%">
        <span style="font-size: 24px; font-weight: 500">Danh sách học viên</span>
        <hr/>
        <div class="table-container">
          <div class="table-header">
            <div class="col">Họ và tên</div>
            <div class="col">Mã học viên</div>
            <div v-if="!isEntrance" class="col">Mã lớp</div>
            <div class="col">Hành động</div>
          </div>
          <div v-if="studentList.length > 0" style="overflow-y: auto; height: 450px;">
            <div
                v-for="(item, index) in studentList"
                :key="index"
                :class="studentIndex === index ? 'table-row__active' : ''"
                class="table-row" @click="handleSelectStudent(item, index)"
            >
              <div class="col">
                {{ item.name }} - {{ item.phone }}
                <span v-if="item.isSuspected" class="badge badge-warning ml-1">Nghi ngờ</span>
              </div>
              <div class="col">{{ item.studentId }}</div>
              <div v-if="!isEntrance" class="col">{{ item?.classroomName }}</div>
              <div class="col" style="display: flex; justify-content: center">
                <button class="btn btn-xs btn-icon mr-2 btn-outline-primary" @click="showImportModal(item)">
                  <i class="el-icon-document-add"></i>
                </button>
              </div>
            </div>
          </div>
          <div v-else style=" color: black; width: 100%; display: flex; justify-content: center">
            Không có dữ liệu
          </div>
        </div>
      </div>
      <ImportSkill :student-selected="studentSelected" />
      <ImportSkillModal :student="studentSelected" :is-entrance="isEntrance" @reloadData="reloadData()"></ImportSkillModal>
    </div>
  </div>
</template>

<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {GET_LIST_STUDENT_ATTENDANCE} from "@/core/services/store/marking/marking.module";
import {AttendanceModel} from "@/view/pages/marking-exam/model/taskPersonal";
import ImportSkill from "@/view/pages/marking-exam/components/ImportSkill.vue";
import ImportSkillModal from "@/view/pages/marking-exam/PersonalTaskList/ImportSkillModal.vue";
import {nextTick} from "vue";

export default {
  name: 'ImportSkillExam',
  components: {ImportSkillModal, ImportSkill},
  computed: {
    isEntrance() {
      return this.$route.query.isEntrance
    },
  },
  data() {
    return {
      loading: false,
      examName: '',
      studentList: [],
      studentIndex: 0,
      studentSelected: {},
    }
  },
  methods: {
    getListStudent() {
      this.loading = true
      this.$store
          .dispatch(GET_LIST_STUDENT_ATTENDANCE, {
            marking_exam_shift_id: this.$route.params.id,
          })
          .then((res) => {
            if (!res.error) {
              this.studentList = res.data.map((item) => new AttendanceModel(item)) ?? [];
              this.examName = res.data[0]?.shift_name ?? "";
              this.studentSelected = this.studentList[this.studentIndex] ?? {};
            }
          })
          .catch((e) => {
            console.log(e, "error");
          })
          .finally(() => {
            this.loading = false;
          });
    },
    handleSelectStudent(student, index) {
      this.studentSelected = student;
      this.studentIndex = index;
    },
    showImportModal(student){
      this.$bvModal.show('Import-Skill-Modal')
      nextTick(() => {
        this.studentSelected = student
      })
    },
    reloadData(){
      this.studentSelected = JSON.parse(JSON.stringify(this.studentSelected))
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Quản lý test đầu vào"},
      {title: "Danh sách tác vụ", name: "PersonalTaskList"},
      {title: "Điểm danh học viên", name: "AttendanceList"},
    ]);
    this.getListStudent();
  },
}
</script>

<style scoped>
.display-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.table-container {
  width: 100%;
  border-radius: 8px;
  overflow-x: auto;
  font-size: 14px;
}

.table-header,
.table-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  padding: 12px 16px;
  align-items: center;
}

.table-header {
  font-weight: bold;
}

.table-row {
  background-color: white;
  border-radius: 5px;
  margin-bottom: 10px;
}

.table-row__active {
  border: 1px solid green;
}

.table-row:hover {
  background-color: #f0f9ff;
}

.col {
  overflow-wrap: break-word;
}

@media (max-width: 768px) {
  .display-grid {
    grid-template-columns: 1fr;
  }

  .table-header,
  .table-row {
    grid-template-columns: 1.5fr 1fr 1fr;
    grid-auto-rows: auto;
    flex-direction: column;
    gap: 4px;
  }
}
</style>
